export default 'USER_CLICKED_PLAY';
